import styled from '@emotion/styled';

const Header = styled('div')({
  position: 'relative',
});

export default Header;
